import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Wheel } from 'react-custom-roulette';
import { getRoulettePrizes, saveRouletteResult, getUserBestScoreDocId } from '../utils/firestoreApi';

const RouletteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  color: white;
  /* padding: 20px; */
  box-sizing: border-box;
`;

const RouletteCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  backdrop-filter: blur(10px);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 8px 32px;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 20px;
    max-width: 95vw;
  }

  @media (max-width: 480px) {
    padding: 15px;
    max-width: 98vw;
    border-radius: 12px;
  }
`;

const Title = styled.h1`
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const WheelContainer = styled.div`
  /* margin: 20px 0; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SpinButton = styled.button`
  padding: 15px 30px;
  border: none;
  border-radius: 25px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(45deg, #FF6B6B, #FF8E8E);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  margin: 20px 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px 24px;
    font-size: 1rem;
    border-radius: 20px;
  }
`;

const ResultModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

const ResultCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

  @media (max-width: 480px) {
    padding: 30px 20px;
    border-radius: 15px;
  }
`;

const ResultTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: ${props => props.$isWin ? '#FF6B6B' : '#666'};
`;

const ResultMessage = styled.p`
  font-size: 1.1rem;
  margin-bottom: 30px;
  color: #333;
  line-height: 1.5;
  white-space: pre-line;
`;

const ResultMessageContainer = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  border-radius: 15px;
  background: ${props => props.$isWin 
    ? 'linear-gradient(135deg, #FFE5E5, #FFF5F5)' 
    : 'linear-gradient(135deg, #F5F5F5, #EEEEEE)'
  };
  border: 2px solid ${props => props.$isWin ? '#FF6B6B' : '#DDD'};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const ResultMessageTitle = styled.div`
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: ${props => props.$isWin ? '#FF6B6B' : '#666'};
  text-align: center;
`;

const ResultMessageText = styled.div`
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
  text-align: center;
  white-space: pre-line;
`;

const PrizeHighlight = styled.span`
  background: linear-gradient(45deg, #FFD700, #FFA500);
  color: white;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: bold;
  margin: 0 2px;
  box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
`;

const LoseMessage = styled.div`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  text-align: center;
  white-space: pre-line;
  
  .emoji {
    font-size: 1.5rem;
    margin: 0 5px;
  }
`;

const ResultButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(45deg, #FF6B6B, #FF8E8E);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: white;
  font-size: 1.1rem;
`;

const ErrorMessage = styled.div`
  color: #FF6B6B;
  text-align: center;
  margin: 20px 0;
  font-size: 1rem;
`;

const CommonMessage = styled.div`
  color: #FF6B6B;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 0.8rem;
  text-align: left;
`;

function RouletteEvent({ userInfo, onComplete }) {
  const [rouletteData, setRouletteData] = useState(null);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadRouletteData();
  }, []);

  const loadRouletteData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getRoulettePrizes();
      setRouletteData(data);
    } catch (err) {
      //console.error('룰렛 데이터 로드 실패:', err);
      setError('룰렛 정보를 불러오는데 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSpinClick = () => {
    if (!mustSpin) {
      // 상품별 확률에 따라 결과 결정
      const random = Math.random();
      //console.log('random', random);
      let cumulativeProbability = 0;
      let selectedPrizeIndex = 0;
      
      // 확률에 따라 상품 선택
      for (let i = 0; i < rouletteData.prizes.length; i++) {
        cumulativeProbability += rouletteData.prizes[i].probability;
        //console.log('cumulativeProbability', cumulativeProbability);
        if (random <= cumulativeProbability) {
          selectedPrizeIndex = i;
          //console.log('selectedPrizeIndex', rouletteData.prizes[selectedPrizeIndex].option);
          break;
        }
      }
      
      setPrizeNumber(selectedPrizeIndex);
      setMustSpin(true);
    }
  };

  const handleStopSpinning = async () => {
    setMustSpin(false);
    
    const selectedPrize = rouletteData.prizes[prizeNumber];
    const isWin = !selectedPrize.isLose;
    
    setResult({
      isWin,
      prizeName: selectedPrize.option,
      message: isWin 
        ? `축하합니다!\n${selectedPrize.option}에 \n당첨되었습니다!` 
        : "아쉽게도 꽝입니다.\n다음 기회에 다시 도전해보세요!"
    });

    // 당첨인 경우에만 파이어베이스에 저장 (꽝이 아닌 경우)
    if (isWin && userInfo) {
      try {
        // 사용자의 최고 점수 문서 ID 조회
        const userDocId = await getUserBestScoreDocId(userInfo.nickname, userInfo.phone);
        
        // 룰렛 결과 저장
        await saveRouletteResult({
          nickname: userInfo.nickname, // 닉네임 직접 사용
          phone: userInfo.phone,
          prizeName: selectedPrize.option,
          userDocId
        });
      } catch (error) {
        //console.error('룰렛 결과 저장 실패:', error);
        // 저장 실패해도 사용자에게는 결과를 보여줌
      }
    }
    
    setShowResult(true);
  };

  const handleResultClose = () => {
    setShowResult(false);
    if (onComplete) {
      onComplete();
    }
  };

  if (isLoading) {
    return (
      <RouletteContainer>
        <LoadingSpinner>룰렛 정보를 불러오는 중...</LoadingSpinner>
      </RouletteContainer>
    );
  }

  if (error) {
    return (
      <RouletteContainer>
        <ErrorMessage>{error}</ErrorMessage>
        <SpinButton onClick={loadRouletteData}>다시 시도</SpinButton>
      </RouletteContainer>
    );
  }

  if (!rouletteData) {
    return (
      <RouletteContainer>
        <ErrorMessage>룰렛 정보를 불러올 수 없습니다.</ErrorMessage>
      </RouletteContainer>
    );
  }

  return (
    <RouletteContainer>
      {/* <RouletteCard> */}
        {/* <Title>🎰 룰렛 이벤트</Title> */}
        <Subtitle>
          <strong style={{fontSize: '1.2rem', color: '#ffffff'}}>응모가 성공적으로 완료되었습니다!</strong><br />
          지금 바로 룰렛을 돌려 특별한 선물을 만나보세요😊
        </Subtitle>
        
        <WheelContainer>
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={rouletteData.prizes}
            onStopSpinning={handleStopSpinning}
            backgroundColors={['#8fd3f5', '#bd4b35', '#c9c0df', '#0e805a', '#d3e067']}
            textColors={['#FFFFFF']}
            fontSize={16}
            radiusLineWidth={2}
            radiusLineColor={'#FFFFFF'}
            outerBorderWidth={3}
            outerBorderColor={'#FFFFFF'}
            innerBorderWidth={2}
            innerBorderColor={'#FFFFFF'}
            innerRadius={5}
            spinDuration={0.8}
          />
        </WheelContainer>
        
        <SpinButton onClick={handleSpinClick} disabled={mustSpin}>
          {mustSpin ? '돌리는 중...' : '룰렛 돌리기'}
        </SpinButton>
      {/* </RouletteCard> */}

      {showResult && (
        <ResultModal>
          <ResultCard>
            <ResultTitle $isWin={result.isWin}>
              {result.isWin ? '🎉 당첨!' : '😢 꽝'}
            </ResultTitle>
            {/* <ResultMessageContainer $isWin={result.isWin}> */}
              {/* <ResultMessageTitle $isWin={result.isWin}>
                {result.isWin ? '축하합니다!' : '아쉽게도'}
              </ResultMessageTitle> */}
              <ResultMessageText>
                {result.isWin ? (
                  <>
                    <PrizeHighlight>{result.prizeName}</PrizeHighlight>에 당첨되셨습니다!
                  </>
                ) : (
                  <>
                    아쉽게도 꽝입니다.
                    <br />
                    다음 기회에 다시 도전해보세요!
                  </>
                )}
              </ResultMessageText>
            {/* </ResultMessageContainer> */}
            <CommonMessage>
            {result.isWin &&
              <>
                <br />
                <span style={{fontSize: '0.7rem', wordBreak: 'keep-all'}}>* 기프티콘 상품은 응모하신 핸드폰 번호로 8월 2주차부터 순차적으로 진행될 예정입니다.</span>
                <br />
              </>
            }
             <span style={{fontSize: '0.7rem', wordBreak: 'keep-all'}}>* 에어팟 프로2에 대한 추첨 이벤트 당첨자 발표는 8월 1주차에 개별 안내해 드립니다.</span>
             <br />
            <span style={{fontSize: '0.7rem', wordBreak: 'keep-all'}}>* 에어팟 프로2 리워드에 대한 제세공과금은 주최 측에서 부담하며, 이후 당첨자에 한해 수령지 확인을 위한 추가 개인 정보 기입이 요구될 수 있습니다.</span>
            </CommonMessage>
            <ResultButton onClick={handleResultClose}>
              확인
            </ResultButton>
          </ResultCard>
        </ResultModal>
      )}
    </RouletteContainer>
  );
}

export default RouletteEvent; 